import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../../components/layout/Layout';
import { getMakecodeArcadePageRootStyle } from '../makecodeArcadePageStyles';
import Button from '../../../components/ui/Button';
import LeftArrowIcon from '../../../components/icons/LeftArrowIcon';
import { explainPaperStyle, explainExampleTitleStyle, explainPaperTitleStyle, explainPaperTextStyle, explainExamplePaperStyle, explainExampleTextStyle, explainExampleImageBoxStyle} from '../../../styles/commonStyles';

const StoryExplain: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useLayoutContext();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);

  return (
    <div style={getMakecodeArcadePageRootStyle(isMobile)}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <Button variant="line" leftIcon={<LeftArrowIcon width={20} height={20} />} onClick={() => navigate('/makecodearcade/explains/')} style={{ marginRight: '16px' }}>
          돌아가기
        </Button>
        <h1 style={{ margin: 0, fontSize: '24px', fontFamily: 'var(--font-family-primary)' }}>Story 알아보기</h1>
      </div>
      <div style={{ marginBottom: '24px', border: '1px solid #ccc', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <h2 style={{ fontWeight: 700, marginBottom: '16px', fontSize: '18px' }}>
          📚 목차
        </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
            <a href="#story-기능-추가하기" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              Story 기능 추가하기
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#story-블록-알아보기" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              Story 블록 알아보기
            </a>
          </li>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '6px' }}>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-변수-선언하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite를 위한 변수 선언
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-변수-선언하면서-동시에-글자색-배경색-바꾸기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 변수 선언하면서 동시에 글자색, 배경색 바꾸기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-글자-크기-조정하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 글자 크기 조정하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-글자-테두리-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 글자 테두리 추가하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-박스-테두리-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 박스 테두리 추가하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-텍스트-변경하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 텍스트 변경하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-아이콘-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 아이콘 추가하기
                </a>
              </li>
            </ul>
        </ul>
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '24px', gap: '16px' }}>
        <img src="/images/makecodearcade/explains/Story/Story01.png" alt="오박사 컷신" style={{ width: '20%', height: 'auto', borderRadius: '8px' }} /> 
        <p style={{ margin: 0, color: 'var(--Color-text-normal)' }}>
          컷신은 게임 플레이 중간에 자동으로 재생되는 짧은 이야기 장면으로, 플레이어가 장면을 직접 조작하지 않아도 등장인물의 대화나 상황 설명, 사건의 전개를 보여줄 수 있는 장치입니다.<br/>
          주로 게임의 <b>스토리텔링</b>이나 <b>몰입감 강화</b>를 위해 사용되며, 화면 속 인물들이 대화를 나누거나 특정 이벤트(예: 보스 등장, 탈출, 감정 표현 등)를 연출할 때 활용됩니다.<br/>
          Makecode Arcade에서는 이런 컷신을 직접 구현하기 어렵거나 번거로울 수 있었지만, <b>Story 확장 기능</b>을 통해 보다 쉽게 대사, 인물 등장, 화면 전환 등을 연출할 수 있게 되었습니다.
        </p>
      </div>
      <h2 style={{ fontWeight: 700, marginBottom: '8px', fontSize: '18px' }} id="text-sprite-기능-추가하기">Story 확장 기능 추가하기</h2>
      <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '24px', gap: '16px' }}>
      <img src="/images/makecodearcade/explains/Story/Story02.png" alt="Story 확장 블록 사진" style={{ width: '20%', height: 'auto', borderRadius: '8px' }} />
      <p style={{ marginBottom: '16px', color: 'var(--Color-text-normal)' }}>
        arcade-story는 컷신을 표시할 수 있는 확장 블록입니다.<br/>
        물론 간단한 컷신을 표시하기 위해서는 대화상자를 활용할 수 있습니다. 하지만 대화상자만이 아니라 캐릭터의 움직임이나 다른 요소들로 더욱 몰입감있게 컷신을 풀어나가고 싶다면 우리는 arcade-story를 사용하는 것을 고려해 볼 수 있습니다.<br/>
        쉽게는 Makecode Arcade에서 텍스트를 스프라이트 형태로 표시한다고 생각하시면 됩니다.<br/>
        먼저 확장 기능을 추가해야 합니다.<br/>
        arcade-text는 Makecode Arcade에서 공식적으로 제공하는 확장 기능이기에 에디터 안에서 바로 추가할 수 있습니다.<br/>
        에디터의 도구상자에서 "확장" 도구상자를 클릭하고 "arcade-text"를 검색, 혹은 스크롤하여 찾으신 다음 선택하여 추가합니다.
      </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', gap: '16px' }}>
        <img src="/images/makecodearcade/explains/Story/Story03.png" alt="Story 도구상자 사진" style={{ width: '20%', height: 'auto' }} />
        <p style={{ margin: 0, color: 'var(--Color-text-normal)' }}>
          제대로 추가된 경우 위쪽과 같은 기능이 도구 상자에 추가되는 것을 확인하실 수 있습니다.
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '24px', gap: '16px' }}>
        <img src="/images/makecodearcade/explains/Story/Story04.png" alt="Story 관련 블록들1" style={{ width: '30%', height: 'auto' }} />
        <img src="/images/makecodearcade/explains/Story/Story05.png" alt="Story 관련 블록들2" style={{ width: '30%', height: 'auto' }} />
        <img src="/images/makecodearcade/explains/Story/Story06.png" alt="Story 관련 블록들3" style={{ width: '30%', height: 'auto' }} />
        
      </div>
      <p style={explainPaperTextStyle}>
          그리고 "Story" 도구 상자를 클릭해보면 위쪽의 블록들이 보이게 됩니다. 크게 텍스트를 표시, 움직임 설정, 선택지 등 컷신에서 활용하는 다수 기능을 포함하고 있습니다.
          이제 이 블록들을 통해 컷신을 표시할 수 있습니다.<br/>
          <br/>
        </p>
      <h2 style={{ fontWeight: 700, marginBottom: '8px', fontSize: '18px' }} id="text-sprite-블록-알아보기">Story 블록 알아보기</h2>
      <p style={{ marginBottom: '16px', color: 'var(--Color-text-normal)' }}>Story 도구 상자의 블록을 알아봅시다.</p>

      <div style={explainPaperStyle} id="text-sprite-변수-선언하기">
        <h3 style={explainPaperTitleStyle}>
          1. 특정 좌표에 텍스트 보여주기
        </h3>
        <img src="/images/makecodearcade/explains/Story/Story07.png" alt="특정 좌표에 텍스트 보여주기" style={{ width: '100%', height: 'auto' }} />
        <p style={explainPaperTextStyle}>
          ""안의 텍스트를 화면의 특정 x좌표, y좌표에 띄워주는 블록입니다.<br/>
        </p>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', gap: '8px' }}>
          <img src="/images/makecodearcade/explains/Story/Story10.png" alt="특정 좌표에 색깔 입힌 텍스트 보여주기" style={{ width: '40%', height: 'auto' }} />
          <img src="/images/makecodearcade/explains/Story/Story11.png" alt="특정 좌표에 색깔 입힌 텍스트 보여주기" style={{ width: '60%', height: 'auto' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', gap: '8px' }}>
          <img src="/images/makecodearcade/explains/Story/Story12.png" alt="특정 좌표에 배경색 입힌 텍스트 보여주기" style={{ width: '40%', height: 'auto' }} />
          <img src="/images/makecodearcade/explains/Story/Story13.png" alt="특정 좌표에 속도를 조절해서 텍스트 보여주기" style={{ width: '60%', height: 'auto' }} />
        </div>
        <p style={explainPaperTextStyle}>
          + 버튼을(1번, 2번, 3번) 눌러 텍스트의 색상, 배경 색상, 글자 속도를 지정할 수도 있습니다.<br/>
        </p>
        <p style={{ marginBottom: '8px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/Story/Story08.png" alt="글자 띄우기 예시1" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/Story/Story09.gif" alt="글자 띄우기 예시2" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-변수-선언하면서-동시에-글자색-배경색-바꾸기">
        <h3 style={explainPaperTitleStyle}>
          2. 기존 스프라이트에 말하기 기능 추가하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/Story/Story14.png" alt="기존 스프라이트에 말하기 기능 추가하기" style={{ width: '50%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
          기존 스프라이트에 말을 하는 기능을 추가합니다.<br/>
          먼저 스프라이트를 추가하고 스프라이트 선언 블록 아래에 다른 블록을 추가하여 사용합니다.<br/>
          <b>변수명</b>에 유의해주세요!
          </p>
        </div>
        <img src="/images/makecodearcade/explains/Story/Story15.png" alt="기존 스프라이트에 말하기 기능 추가하기 실사용" style={{ width: '100%', height: 'auto' }} />
        <p style={explainPaperTextStyle}>
          <b>as</b>는 글자색을 변경할 수 있으며, <b>on</b>은 글자의 배경색을 변경할 수 있습니다.
        </p>
        <p style={{ marginBottom: '8px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/Story/Story14.png" alt="말하기 기능 블록 예시" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/Story/Story15.png" alt="말하기 기능 적용 예시" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-글자-크기-조정하기">
        <h3 style={explainPaperTitleStyle}>
          3. TextSprite 글자 크기 조정하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext11.png" alt="Text Sprite 글자 크기 조정하기" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
          textSprite 변수 안의 text 스프라이트의 크기(height)를 조정할 수 있습니다.<br/>
          기본 높이는 0으로 시작하며 원하는 높이로 조정할 수 있습니다.<br/>
          <b style={{ color: 'red' }}>다만, 아직 한국어 텍스트에 대해서는 적용되지 않습니다.ㅠㅠ....</b>
        </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext13.png" alt="Text Sprite 글자 크기 조정 적용" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext14.png" alt="Text Sprite 글자 크기 조정 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>

      </div>

      <div style={explainPaperStyle} id="text-sprite-글자-테두리-추가하기">
          <h3 style={explainPaperTitleStyle}>
            4. TextSprite 글자 테두리 추가하기
          </h3>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext15.png" alt="Text Sprite 글자 테두리 추가 적용" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            textSprite 변수 안의 text 스프라이트의 테두리의 <b>두께</b>와 <b>색상</b>을 추가할 수 있습니다.
          </p>
          </div>
          <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
            사용 예시:
          </p>
          <div style={explainExamplePaperStyle}>
            <div style={explainExampleImageBoxStyle}>
              <img src="/images/makecodearcade/explains/SpriteText/arcadetext16.png" alt="Text Sprite 글자 테두리 추가 적용" style={{ width: '70%', height: 'auto' }} />
              <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
              <img src="/images/makecodearcade/explains/SpriteText/arcadetext17.png" alt="Text Sprite 글자 테두리 추가 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
            </div>
          </div>
        </div>

      <div style={explainPaperStyle} id="text-sprite-박스-테두리-추가하기">
        <h3 style={explainPaperTitleStyle}>
          5. TextSprite 박스 테두리 추가하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext18.png" alt="Text Sprite 박스 테두리 추가 적용" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            textSprite 변수 안의 text 스프라이트의 박스 테두리의 <b>두께</b>와 <b>색상</b>을 추가할 수 있습니다.
          </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext19.png" alt="Text Sprite 박스 테두리 추가 적용" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} /> 
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext20.png" alt="Text Sprite 박스 테두리 추가 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-텍스트-변경하기">
        <h3 style={explainPaperTitleStyle}>
          6. TextSprite 텍스트 변경하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext21.png" alt="Text Sprite 텍스트 변경하기" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            textSprite 변수 안의 text 스프라이트의 텍스트를 변경할 수 있습니다.
          </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext22.png" alt="Text Sprite 텍스트 변경하기" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext23.gif" alt="Text Sprite 텍스트 변경하기" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>

      <div style={explainPaperStyle} id="text-sprite-아이콘-추가하기">
        <h3 style={explainPaperTitleStyle}>
          7. TextSprite 아이콘 추가하기
        </h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', marginBottom: '16px' }}>
          <img src="/images/makecodearcade/explains/SpriteText/arcadetext23.png" alt="Text Sprite 아이콘 추가하기" style={{ width: '30%', height: 'auto' }} />
          <p style={{ ...explainPaperTextStyle, fontSize: '14px' }}>
            text 스프라이트 앞에 나만의 아이콘을 추가할 수 있습니다.
          </p>
        </div>
        <p style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          사용 예시:
        </p>
        <div style={explainExamplePaperStyle}>
          <div style={explainExampleImageBoxStyle}>
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext24.png" alt="Text Sprite 아이콘 블록 추가" style={{ width: '70%', height: 'auto' }} />
            <div style={{ width: 1, alignSelf: 'stretch', backgroundColor: 'var(--Color-line-normal)', margin: '0 8px' }} />
            <img src="/images/makecodearcade/explains/SpriteText/arcadetext25.png" alt="Text Sprite 아이콘 추가하기 시뮬레이터" style={{ width: '25%', height: 'auto' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryExplain;